import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const UserRoundSearch: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '10', cy: '8', r: '5' }],
    ['path', { d: 'M2 21a8 8 0 0 1 10.434-7.62' }],
    ['circle', { cx: '18', cy: '18', r: '3' }],
    ['path', { d: 'm22 22-1.9-1.9' }],
  ],
];

export default UserRoundSearch;
